import React, { useState, useEffect } from 'react';
import { translate } from '@utils/i18n';
import { Loader, Text } from '@ui';
import './TrialRunLoader.scss';
const LOADING_MESSAGES = [
    'searching_unanswered_questions',
    'comparing_historical_data',
    'reviewing_grammar_spelling_style',
    'analyzing_overall_impact'
];
const MESSAGE_ROTATION_INTERVAL = 3000; // 3 seconds
export default function TrialRunLoader() {
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % LOADING_MESSAGES.length);
        }, MESSAGE_ROTATION_INTERVAL);
        return () => clearInterval(interval);
    }, []);
    const currentMessage = LOADING_MESSAGES[currentMessageIndex];
    return (React.createElement("div", { className: "trial-run-loader" },
        React.createElement("div", { className: "trial-run-loader__spinner" },
            React.createElement(Loader, { size: "64" })),
        React.createElement("div", { className: "trial-run-loader__message" },
            React.createElement(Text, { variant: "body", key: currentMessage }, translate(currentMessage, { namespace: 'features.iim_review.trial_run_loader' })))));
}
